'use client'
import Icons from '@/shared/components/icon/Icons'
import { Text } from '@/shared/components/typography'

interface ParkinglotMapHeaderProps {
  setIsDetailMapOpen: React.Dispatch<React.SetStateAction<boolean>>
}

function ParkinglotMapHeader({ setIsDetailMapOpen }: ParkinglotMapHeaderProps) {
  const onCloseRoadView = () => {
    setIsDetailMapOpen(false)
  }

  return (
    <div className={`absolute left-0 top-0 z-20 flex w-full flex-col`}>
      <div className="flex max-h-[56px] w-full items-center justify-start bg-010">
        <div className="mx-auto flex h-[56px] w-full items-center">
          <div className="ml-[16px] mr-[8px] h-[24px] w-[24px] cursor-pointer" onClick={onCloseRoadView}>
            <Icons.BackIcon stroke="currentColor" color="#263238" />
          </div>
          <Text level="text3" weight="regular" color="text090">
            상세 주소
          </Text>
        </div>
      </div>
    </div>
  )
}

export default ParkinglotMapHeader
